// © 2025 Camp Promethean, LLC. All Rights Reserved.
import * as React from "react"

const MOBILE_BREAKPOINT = 768

function getIsMobile() {
  if (typeof window === "undefined") return false
  return window.innerWidth < MOBILE_BREAKPOINT
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(getIsMobile)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }
    mql.addEventListener("change", onChange)
    setIsMobile(getIsMobile())
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}

/** True when the viewport is taller than wide (typical phone upright). */
export function useIsPortrait() {
  const [portrait, setPortrait] = React.useState(() => {
    if (typeof window === "undefined") return true
    return window.matchMedia("(orientation: portrait)").matches
  })

  React.useEffect(() => {
    const mql = window.matchMedia("(orientation: portrait)")
    const onChange = () => setPortrait(mql.matches)
    mql.addEventListener("change", onChange)
    setPortrait(mql.matches)
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return portrait
}
